export class OutageWaningInfo {
  constructor(show, remainingTime) {
    this.show = show;
    this.remainingTime = remainingTime;
  }
}

export const OutageEvents = (() => {
  const warningEventSubscibers = [];
  const outageEventSubscibers = [];
  return {
    SubscribeForWarning(subscriber) {
      warningEventSubscibers.push(subscriber);
    },
    NotifyWarningSubscribers(warningInfo) {
      warningEventSubscibers.forEach((subscriber) => {
        subscriber(warningInfo);
      });
    },
    SubscribeForOutage(subscriber) {
      outageEventSubscibers.push(subscriber);
    },
    NotifyOutageSubscribers(isOutage) {
      outageEventSubscibers.forEach((subscriber) => {
        subscriber(isOutage);
      });
    },
  };
})();
